import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var FacebookIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M24.0099 7.68003C19.7436 7.66828 15.6303 9.26858 12.4938 12.1606C9.35725 15.0527 7.42889 19.0228 7.0951 23.2761C6.76132 27.5294 8.04674 31.7517 10.6937 35.0976C13.3407 38.4435 17.1541 40.666 21.37 41.3199V29.5H17.07V24.5999H21.37V20.88C21.37 20.6066 21.37 20.3466 21.37 20.0999C21.66 16.3499 24.1099 14.29 27.7299 14.29H28.4198C29.4582 14.3337 30.4934 14.4372 31.5199 14.5999V18.77H29.38C28.7354 18.7365 28.097 18.9119 27.5599 19.27C27.2452 19.5264 26.9964 19.8546 26.8346 20.2269C26.6728 20.5992 26.6027 21.0049 26.63 21.41V24.5799H31.32L30.57 29.48H26.63V41.3C30.8468 40.646 34.6607 38.4228 37.3078 35.0758C39.9548 31.7288 41.2395 27.5051 40.9044 23.2511C40.5693 18.997 38.6391 15.0267 35.5006 12.1355C32.3621 9.24424 28.2471 7.64569 23.9799 7.66001L24.0099 7.68003Z"
  }));
});
FacebookIcon.displayName = 'FacebookIcon';
FacebookIcon.defaultProps = {
  'aria-label': 'Facebook'
};
export default FacebookIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/FacebookIcon/index.js
// module id = 1837
// module chunks = 12